import { useId } from "react";

/*
 * A labelled Settings section.
 *
 * Settings groups (Profile, Connected Accounts, Account, Personalization) are
 * separated by an uppercase group label rather than by nesting one card inside
 * another. The section is a landmark named by its own heading, so
 * `getByRole("region", { name })` keeps working for every group.
 *
 * Presentation only: it owns no state, no navigation and no account behaviour.
 */
export default function SettingsSection({
  title,
  titleAs: Title = "h3",
  description,
  className = "",
  children,
}) {
  const headingId = `lz-settings-section-${useId().replace(/:/g, "")}`;

  return (
    <section
      className={`lz-settings-section-block ${className}`.trim()}
      aria-labelledby={headingId}
    >
      <Title id={headingId} className="lz-settings-section-block__title">
        {title}
      </Title>
      {description ? (
        <p className="lz-settings-section-block__description">{description}</p>
      ) : null}
      {children}
    </section>
  );
}
